define('gameInterfaces/GameInterfacesShell',[], function() {

    /**
     * A lightweight shell intended for use with game interfaces
     */
    function GameInterfacesShell() {

    }

    return GameInterfacesShell;

});

